(function () {
  function getBtaIframeDocument() {
    var iframe = document.querySelector('#bta-widget-container iframe');
    if (!iframe) return null;
    try {
      return iframe.contentDocument || iframe.contentWindow.document;
    } catch (e) {
      return null;
    }
  }

  // BTAはPCではinput[type=number]、モバイル端末ではselectを描画する（name形式は共通）
  function getQuantityControls(doc) {
    return Array.prototype.slice.call(
      doc.querySelectorAll('input[name$="_quantity"], select[name$="_quantity"]')
    );
  }

  // 同行の td に「グループ」が含まれるかでグループ判定
  // （selectは選択肢に2以上があればグループ）
  function isGroupInput(input) {
    if (input.tagName === 'SELECT' && input.querySelector('option[value="2"]')) return true;
    var tr = input.closest('tr');
    if (!tr) return false;
    return Array.from(tr.querySelectorAll('td')).some(function (td) {
      return /グループ/.test(td.textContent);
    });
  }

  // React管理inputへの安全な値セット
  function setInputValue(input, value) {
    var win = input.ownerDocument.defaultView || window;
    var isSelect = input.tagName === 'SELECT';
    var ctor = isSelect ? win.HTMLSelectElement : win.HTMLInputElement;
    var proto = ctor && ctor.prototype;
    var descriptor = proto && Object.getOwnPropertyDescriptor(proto, 'value');
    var next = String(value);
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, next);
    } else {
      input.value = next;
    }
    if (!isSelect) input.setAttribute('value', next);
    input.dispatchEvent(new win.Event('input', { bubbles: true }));
    input.dispatchEvent(new win.Event('change', { bubbles: true }));
  }

  // グループ: 2〜5名 / 1名参加: 1名固定
  function getQuantityRange(input) {
    return isGroupInput(input) ? { min: 2, max: 5 } : { min: 1, max: 1 };
  }

  function normalizeInput(input) {
    var val = parseInt(input.value, 10);
    var range = getQuantityRange(input);
    if (input.tagName !== 'SELECT') {
      input.setAttribute('min', String(range.min));
      input.setAttribute('max', String(range.max));
    }
    if (val > 0 && val < range.min) setInputValue(input, range.min);
    if (val > range.max) setInputValue(input, range.max);
  }

  // グループ/1名を問わず、許容範囲の人数が入っていれば「有効な選択」
  // （selectにはmin属性がないため、属性ではなくgetQuantityRangeで判定する）
  function isActiveSelection(input) {
    var value = parseInt(input.value, 10);
    if (isNaN(value)) return false;
    return value > 0 && value >= getQuantityRange(input).min;
  }

  // 4バリアントのうち1つでも有効な選択があれば、残りをdisabled化する
  // （BTAは値をReact側stateで保持しており、disabledにしても値・金額計算に影響しないことを確認済み）
  function applyExclusiveSelection(inputs) {
    var activeInput = null;
    for (var i = 0; i < inputs.length; i++) {
      if (isActiveSelection(inputs[i])) {
        activeInput = inputs[i];
        break;
      }
    }
    inputs.forEach(function (input) {
      var shouldDisable = !!activeInput && input !== activeInput;
      if (input.disabled === shouldDisable) return;
      input.disabled = shouldDisable;
      input.style.opacity = shouldDisable ? '0.4' : '';
      input.style.cursor = shouldDisable ? 'not-allowed' : '';
    });
  }

  function attachInputListeners(input) {
    if (input.dataset.hankyuQtyAttached) return;
    input.dataset.hankyuQtyAttached = 'true';
    var eventNames = input.tagName === 'SELECT' ? ['change'] : ['input', 'change', 'keyup', 'blur'];
    eventNames.forEach(function (eventName) {
      input.addEventListener(eventName, function () {
        normalizeInput(input);
        applyExclusiveSelection(getQuantityControls(input.ownerDocument));
      });
    });
  }

  // iframeのNextボタンにクリックリスナーを付けて即時適用（補助）
  function tryAttachNextListener() {
    var doc = getBtaIframeDocument();
    if (!doc || !doc.body || doc.__hankyuNextAttached) return;
    doc.__hankyuNextAttached = true;
    doc.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      if (/Next|次へ/.test((button.textContent || '').trim())) {
        setTimeout(tick, 100);
        setTimeout(tick, 400);
      }
    }, true);
  }

  // Add to Cart / Book Now直前の最終防御:
  // 有効な選択が2件以上ある場合のみ送信を止める（通常操作では発火しない想定）
  function tryAttachBookGuard() {
    var doc = getBtaIframeDocument();
    if (!doc || !doc.body || doc.__hankyuBookGuardAttached) return;
    doc.__hankyuBookGuardAttached = true;
    doc.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-type="submit"]');
      if (!button) return;
      var activeCount = getQuantityControls(doc).filter(isActiveSelection).length;
      if (activeCount >= 2) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  // 500msごとにiframe内のinputを確認・制御（親ページから直接ポーリング）
  function tick() {
    var doc = getBtaIframeDocument();
    if (!doc || !doc.body) return;

    var inputs = getQuantityControls(doc);
    inputs.forEach(function (input) {
      normalizeInput(input);
      attachInputListeners(input);
    });
    applyExclusiveSelection(inputs);

    tryAttachNextListener();
    tryAttachBookGuard();
  }

  setInterval(tick, 500);
})();
